module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/luty-a6cd6fe623104c53bfed6de153aaed7d.png";